import { useQuery } from '@tanstack/react-query';

import { env } from '../utils/env';

export interface SummerplayTypesResult {
  summerplay_scenarios: unknown[];
  summerplay_types: SummerplayType[];
}

export interface SummerplayType {
  id: number;
  name: string;
  description: string;
  pdf: string;
}

export const useSummerplayTypes = () => {
  const { data, error, isLoading } = useQuery<SummerplayTypesResult>({
    queryKey: ['newSummerplay', 'types'],
    queryFn: () =>
      fetch(`${env.API_URL}/newSummerplay/types`).then((res) => res.json()),
  });

  return {
    summerplayTypes: data?.summerplay_types ?? [],
    isLoading,
    error,
  };
};
